import "core-js/stable";
import "regenerator-runtime/runtime";
import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import store from './store'
import VueRouter from 'vue-router'
import VueLogger from 'vuejs-logger';
import LoginMain from './components/modules/login/LoginMain'
import MainMain from './components/modules/main/MainMain'
import HomeMain from './components/modules/home/HomeMain'
import FormacionMain from './components/modules/formacion/FormacionMain'
import BolsaTrabajoMain from './components/modules/bolsa-trabajo/BolsaTrabajoMain'
import NewsletterMain from './components/modules/newsletter/NewsletterMain'
import TramitesMain from './components/modules/tramites/TramitesMain'
import MasMain from './components/modules/mas/MasMain'
import VueI18n from 'vue-i18n'
import getBrowserLocale from "@/components/util/get-browser-locale"
import { v4 as uuidv4 } from 'uuid';
import VueGtag from "vue-gtag"
import discovery from "./discovery"

const debug = process.env.NODE_ENV !== 'production'
Vue.config.productionTip = !debug;

// **********************************************************

Vue.use(VueI18n)


function getStartingLocale() {
  const browserLocale = getBrowserLocale({ countryCodeOnly: true })
  const supportedLocales = ['es','en'];
  if (supportedLocales.includes(browserLocale)) {
    return browserLocale
  } else {
    return process.env.VUE_APP_I18N_LOCALE || "en"
  }
}

function loadLocaleMessages() {
  const locales = require.context(
    "./locales",
    true,
    /[A-Za-z0-9-_,\s]+\.json$/i
  );
  const messages = {};
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      messages[locale] = locales(key);
    }
  });

  return messages;
}

export const i18n = new VueI18n({
  locale: getStartingLocale(),
  fallbackLocale: 'en',
  messages: loadLocaleMessages()
})

// **********************************************************

Vue.use(VueRouter)

const routes = [

  { path: '/', name: 'login', component: LoginMain },
  { path: '/main', name: 'main', component: MainMain,
    children: [
      {
        path: 'home',
        name: 'home',
        component: HomeMain
      },
      {
        path: 'formacion',
        name: 'formacion',
        component: FormacionMain
      },
      {
        path: 'bolsa-trabajo',
        name: 'bolsa-trabajo',
        component: BolsaTrabajoMain
      },
      {
        path: 'newsletter',
        name: 'newsletter',
        component: NewsletterMain
      },
      {
        path: 'tramites',
        name: 'tramites',
        component: TramitesMain
      },
      {
        path: 'mas',
        name: 'mas',
        component: MasMain
      },
    ]
  },
];

const router = new VueRouter({
  routes
})

const isProduction = process.env.NODE_ENV === 'production';

// **********************************************************

const options = {
    isEnabled: true,
    logLevel : isProduction ? 'error' : 'debug',
    stringifyArguments : false,
    showLogLevel : true,
    showMethodName : true,
    separator: '|',
    showConsoleColors: true
};

Vue.use(VueLogger, options);
Vue.use(require('vue-moment'));

  const vue =
      new Vue({
        vuetify,
        store,
        router,
        i18n,
        render: h => h(App)
      }).$mount('#app');

  window.$vue = vue;

//FIXME: tiene que ser din�mico
window.$vue.$vuetify.lang.current = 'es';

window.$store = store;
window.$router = router;

Vue.use(VueGtag, {
  config: { id: discovery.icoev_gtag_id }
}, router);

// **********************************************************

if (!window.localStorage.getItem("icoev-device-uuid"))
    window.localStorage.setItem("icoev-device-uuid", uuidv4().toString().toUpperCase().substring(4,18));

window.$store.commit('icoev/setDeviceUuid', window.localStorage.getItem("icoev-device-uuid"));
window.$store.commit('icoev/setDevicePlatform', 'browser');